import React from 'react';

export const LoadingSpinner = ({ text, padding }) => (
    <div className="d-flex align-items-center" style={{ padding: padding ? '1rem' : '0' }}>
        <i className="fa fa-spinner fa-spin" style={{ fontSize: '1.2rem', marginRight: '1rem', color: '#6f7071' }} />
        {text && <span>{text}...</span>}
    </div>
);
